import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  greenPoint: {
    borderRadius: 50,
    width: "4px",
    height: "4px",
    backgroundColor: "#2EEFAA",
    marginRight: theme.spacing(1),
  },
  itemTextStyle: {
    fontSize: "12px",
  },
  textStyle: {
    fontSize: "12px",
    textAlign: "left",
  },
  limitText: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
